<template>
    <div class="col-md-3 col-6">
      <div class="item_rate vertical-rate animate">
        <div class="item_image">
          <NuxtLink :to="`/place/${place.tenant}`">
            <NuxtImg
              :src="place.main_image"
              :alt="place.name"
              loading="lazy"
              :custom="true"
              v-slot="{ src, isLoaded, imgAttrs }"
            >
              <!-- Show the actual image when loaded -->
              <img
                v-if="isLoaded"
                v-bind="imgAttrs"
                :src="src"
              >

              <!-- Show a placeholder while loading -->
              <img
                v-else
                :src="'/website/assets/img/default-featured-image.jpeg'"
              >
            </NuxtImg>

          </NuxtLink>
        </div>
        <div class="item_content w-100">
          <h3>
            <NuxtLink :to="`/place/${place.tenant}`">
              {{ place.name }}
            </NuxtLink>
          </h3>
          <div class="stars suggestionItems">
            <Vue3StarRatings :modelValue="place.total_rate_db" :numberOfStars="5" :starSize="18" :disableClick="true" />
            <span class="rate">( {{ place.total_rate_db.toFixed(1) }} )</span>
          </div>
          <div class="text-container">
            <p class="text_item text">
              <!-- {{ place.description }} -->
              {{ limitedDescription }}
            </p>
          </div>
          <div class="rates">
            <div class="visitors relative">
              <img src="/website/assets/img/icons/circle_user.png" alt="user" />
              <span>{{ place.rates_count_db }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
    import Vue3StarRatings from '~/components/Vue3StarRatings.vue'
    import { computed } from 'vue'

    const props = defineProps({
      place: Object
    });


    const slugify = (text) => text.replace(/\s+/g, '-').toLowerCase();


    const limitedDescription = computed(() => {
      return props.place?.description ? props.place?.description?.substring(0, 75) : '';
    });

  </script>